export function Delay(time: number) {
  return new Promise(resolve => {
    setTimeout(() => {
      return resolve(true);
    }, time);
  });
}
